import { IntlShape } from 'react-intl';

import { getNationalIdRules, validateNationalId } from '@src/packages/utils/nationalId';
import { createPhoneFormValidator } from '@src/packages/utils/hooks/useRulesByCountry/phone/phoneFormValidators';
import { EMAIL_REGEX } from '@src/packages/utils/validation/email';

interface IValidator {
  idCard: (_, value: string) => Promise<void>;
  phone: ReturnType<typeof createPhoneFormValidator>;
  name: (_, value: string) => Promise<void>;
  lastName: (_, value: string) => Promise<void>;
  email: (_, value: string) => Promise<void>;
}

/**
 * Form validators keyed by address/org country (ISO or display name).
 */
export const validator = (country: string | null | undefined, intl: IntlShape): IValidator => {
  const phone = createPhoneFormValidator(intl);
  const idRules = getNationalIdRules(country);

  return {
    phone,
    email: async (_, value) => {
      if (!value) {
        return Promise.resolve();
      }
      if (!EMAIL_REGEX.test(value)) {
        return Promise.reject(
          new Error(intl.formatMessage({ id: 'validation.email.restrictedCharacter' })),
        );
      }
      return Promise.resolve();
    },
    idCard: async (_, value) => {
      if (!validateNationalId(country, value || '')) {
        return Promise.reject(
          new Error(
            intl.formatMessage({
              id: idRules.invalidKey,
            }),
          ),
        );
      }
      return Promise.resolve();
    },
    name: async (_, value) => {
      if (!value || value.trim() === '') {
        return Promise.reject(new Error(intl.formatMessage({ id: 'form.required' })));
      }
      if (/\d/.test(value)) {
        return Promise.reject(
          new Error(intl.formatMessage({ id: 'validation.noNumbers.allowed' })),
        );
      }
      return Promise.resolve();
    },
    lastName: async (_, value) => {
      if (!value || value.trim() === '') {
        return Promise.reject(new Error(intl.formatMessage({ id: 'form.required' })));
      }
      if (/\d/.test(value)) {
        return Promise.reject(
          new Error(intl.formatMessage({ id: 'validation.noNumbers.allowed' })),
        );
      }
      return Promise.resolve();
    },
  };
};
